import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CourseCreateComponent } from './course-create/course-create.component';
import { CourseEditComponent } from './course-edit/course-edit.component';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseViewComponent } from './course-view/course-view.component';
import { ManageComponent } from './manage/manage.component';
import { CourseAddEditComponent } from './course-add-edit/course-add-edit.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { CourseReportsComponent } from './course-reports/course-reports.component';
import { CourseReportsChartComponent } from './course-reports-chart/course-reports-chart.component';
import { PasswordGuard } from 'app/shared/auth/password.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'course-list', component: CourseListComponent,
        data: {
          title: 'Course List'
        }
      },
      {
        path: 'course-create', component: CourseCreateComponent,
        data: {
          title: 'Course Create'
        }
      },
      {
        path: 'course-edit/:id', component: CourseEditComponent,
        data: {
          title: 'Course Edit'
        }
      },
      // {
      //   path: 'course-add-edit', component: CourseAddEditComponent,
      //   data: {
      //     title: 'Course'
      //   }
      // },
      {
        path: 'course-view/:id', component: CourseViewComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment'] } 
      },
      {
        path: 'course-manage/:id', component: ManageComponent,
        data: {
          title: 'Course Manage'
        }
      },
      {
        path: 'reports', component: CourseReportsComponent,
        data: {
          title: 'Course Reports'
        }
      },
      {
        path: 'course-reports', component: CourseReportsChartComponent,
        data: {
          title: 'Course Reports'
        }
      },
      {
        path: 'course-reports2', component: CourseReportsChartComponent,
        data: {
          title: 'Course Reports'
        }
      },
      {
        path: 'course-add-edit',
        component: CourseAddEditComponent,
        // canActivate: [PasswordGuard],
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CourseRoutingModule { }
